import { postRequest } from '../../../shared/utils';

export type IndusRecord = {
  id: number;
  indus: string;
};

function normalizeIndusLabel(value: unknown): string {
  return typeof value === 'string' ? value.trim().toLowerCase() : '';
}

/** Fetches INDUS lookup rows (`id`, `indus`) for the provided screen context. */
export async function fetchIndusRecords(screenGridId: number): Promise<IndusRecord[]> {
  const result = await postRequest('/api/records', {
    columns: ['id', 'indus'],
    screenGridId,
    schema: 'npi',
    table: 'indus',
  });

  const rows = result?.data?.npi_indus;
  if (!Array.isArray(rows)) {
    return [];
  }

  return rows.filter((row) => Number.isFinite(Number(row?.id)));
}

/** Resolves an INDUS id by label using case-insensitive matching. */
export function getIndusIdByName(indusRecords: IndusRecord[], label: string): number | null {
  const normalizedLabel = normalizeIndusLabel(label);
  const match = indusRecords.find(
    (record) => normalizeIndusLabel(record.indus) === normalizedLabel,
  );
  return match ? Number(match.id) : null;
}
